import { SELECT_CLIENT } from '../actions/client';
import { VALIDATE_CART } from '../actions/cart';

export const initialState = {
  userId: -1,
  clientId: -1,
  email: '',
  error: null,
  credit: 0,
};

const client = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_CLIENT:
      return {
        ...state,
        ...(action.client ? action.client : initialState),
      };
    case VALIDATE_CART:
      return initialState;
    default:
      return state;
  }
};

export default client;
